import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CONTACT_INFO, COMPANY_INFO } from '../utils/constants';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleServices = () => {
    setIsServicesOpen(!isServicesOpen);
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="header">
        {/* Top Contact Bar */}
        <div className="top-bar">
          <div className="container">
            <div className="contact-info">
              <div className="contact-item">
                <span className="icon">📧</span>
                <a href={`mailto:${CONTACT_INFO.email}`}>{CONTACT_INFO.email}</a>
              </div>
              <div className="contact-item">
                <span className="icon">📱</span>
                <a href={`tel:${CONTACT_INFO.phone}`}>{CONTACT_INFO.phone}</a>
              </div>
              <div className="contact-item">
                <span className="icon">📍</span>
                <span>{CONTACT_INFO.address}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Main Navigation */}
        <nav className="main-nav">
          <div className="container">
            <div className="nav-content">
              <Link to="/" className="logo">
                <img src="/pickup-rental-truck-dubai-logo.png" alt={COMPANY_INFO.name} />
                <span className="logo-text">{COMPANY_INFO.name}</span>
              </Link>

              <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
                <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
                  Home
                </Link>
                <Link to="/about" className={`nav-link ${isActive('/about') ? 'active' : ''}`}>
                  About Us
                </Link>
                <div className={`nav-dropdown ${isServicesOpen ? 'active' : ''}`}>
                  <Link to="/services" className={`nav-link ${isActive('/services') ? 'active' : ''}`} onClick={toggleServices}>
                    Our Services <i className="fas fa-chevron-down dropdown-icon"></i>
                  </Link>
                  <div className={`dropdown-menu ${isServicesOpen ? 'active' : ''}`}>
                    <Link to="/1-ton-truck" className="dropdown-link">1 Ton Pickup Truck</Link>
                    <Link to="/3-ton-truck" className="dropdown-link">3 Ton Pickup Truck</Link>
                    <Link to="/5-ton-truck" className="dropdown-link">5 Ton Pickup Truck</Link>
                    <Link to="/7-ton-truck" className="dropdown-link">7 Ton Pickup Truck</Link>
                    <Link to="/10-ton-truck" className="dropdown-link">10 Ton Pickup Truck</Link>
                  </div>
                </div>
                <Link to="/blog" className={`nav-link ${isActive('/blog') ? 'active' : ''}`}>
                  Blog
                </Link>
                <Link to="/contact" className={`nav-link ${isActive('/contact') ? 'active' : ''}`}>
                  Contact Us
                </Link>
                <a href={`tel:${CONTACT_INFO.phone}`} className="cta-button">
                  Call Now
                </a>
              </div>

              <button className="mobile-menu-toggle" onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </nav>
      </header>
  );
};

export default Header;
